export const today: string = new Date().toISOString().slice(0, 10);

export default function formatDate(date: any) {
    return new Date(date).toLocaleDateString();
}
